import { memo } from "react";
import { ChatbotContextProvider } from "./ChatbotContext";
import { EditingChatbotPrompt } from "./EditingChatbotPrompt";
import { LiveChatbotPrompt } from "./LiveChatbotPrompt";
import { ChatbotPromptProps } from "./types";

export const Chatbot = memo(function Chatbot(props: ChatbotPromptProps) {
  const Component = props.isEditing ? EditingChatbotPrompt : LiveChatbotPrompt;
  return (
    <ChatbotContextProvider {...props}>
      <Component />
    </ChatbotContextProvider>
  );
});
